module.exports = __webpack_public_path__ + "static/media/vinheta_web.97039f9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vinheta_web.mp4
// module id = YIgc
// module chunks = 0